import { useRef, useCallback } from "react";

export function useDebounce<F extends (...args: unknown[]) => unknown>(fn: F, delay?: number) {
  const handle = useRef<number>();

  const runFn = useCallback(
    (...args: unknown[]) => {
      handle.current = undefined;
      fn(...args);
    },
    [fn]
  );

  const debouncedFn = useCallback(
    (...args: unknown[]) => {
      if (handle.current) {
        clearTimeout(handle.current);
      }

      handle.current = window.setTimeout(runFn, delay || 0, ...args);
    },
    [handle, runFn, delay]
  );

  return debouncedFn;
}
